/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { BurnListStatus } from '../models/burn-list-status';
import { BurnListRegion } from '../models/burn-list-region';
import { BurnList } from '../models/burn-list';
import { BurnCoup } from '../models/burn-coup';
import { BurnListComment } from '../models/burn-list-comment';
import { AddCommentRequest } from '../models/add-comment-request';
import { UpdateCommentRequest } from '../models/update-comment-request';
@Injectable({
  providedIn: 'root',
})
class BurnListService extends __BaseService {
  static readonly BurnListGetBurnListStatusesPath = '/api/BurnList/GetBurnListStatuses';
  static readonly BurnListGetBurnListTypesPath = '/api/BurnList/GetBurnListTypes';
  static readonly BurnListGetBurnListRegionsPath = '/api/BurnList/GetBurnListRegions';
  static readonly BurnListGetBurnListsPath = '/api/BurnList/GetBurnLists/{customerId}';
  static readonly BurnListGetBurnListPath = '/api/BurnList/GetBurnList/{customerId}/{burnListId}';
  static readonly BurnListCreateBurnListPath = '/api/BurnList/CreateBurnList';
  static readonly BurnListUpdateBurnListPath = '/api/BurnList/UpdateBurnList';
  static readonly BurnListUpdateBurnListStatusPath = '/api/BurnList/UpdateBurnListStatus/{customerId}/{burnListId}/{burnListStatusId}';
  static readonly BurnListDeleteBurnListPath = '/api/BurnList/DeleteBurnList/{customerId}/{burnListId}';
  static readonly BurnListAddBurnCoupPath = '/api/BurnList/AddBurnCoup/{customerId}/{burnListId}/{geoAssetId}';
  static readonly BurnListRemoveBurnCoupPath = '/api/BurnList/RemoveBurnCoup/{customerId}/{burnListId}/{geoAssetId}';
  static readonly BurnListDisableBurnCoupPath = '/api/BurnList/DisableBurnCoup/{customerId}/{burnCoupId}';
  static readonly BurnListEnableBurnCoupPath = '/api/BurnList/EnableBurnCoup/{customerId}/{burnCoupId}';
  static readonly BurnListStartBurnPath = '/api/BurnList/StartBurn/{customerId}/{burnCoupId}';
  static readonly BurnListFinishBurnPath = '/api/BurnList/FinishBurn/{customerId}/{burnCoupId}';
  static readonly BurnListCancelBurnPath = '/api/BurnList/CancelBurn/{customerId}/{burnCoupId}';
  static readonly BurnListAddCommentPath = '/api/BurnList/AddComment/{customerId}/{burnListId}';
  static readonly BurnListUpdateCommentPath = '/api/BurnList/UpdateComment/{customerId}/{commentId}';
  static readonly BurnListDeleteCommentPath = '/api/BurnList/DeleteComment/{customerId}/{commentId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  BurnListGetBurnListStatusesResponse(): __Observable<__StrictHttpResponse<Array<BurnListStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/BurnList/GetBurnListStatuses`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BurnListStatus>>;
      })
    );
  }  BurnListGetBurnListStatuses(): __Observable<Array<BurnListStatus>> {
    return this.BurnListGetBurnListStatusesResponse().pipe(
      __map(_r => _r.body as Array<BurnListStatus>)
    );
  }
  BurnListGetBurnListTypesResponse(): __Observable<__StrictHttpResponse<Array<BurnListStatus>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/BurnList/GetBurnListTypes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BurnListStatus>>;
      })
    );
  }  BurnListGetBurnListTypes(): __Observable<Array<BurnListStatus>> {
    return this.BurnListGetBurnListTypesResponse().pipe(
      __map(_r => _r.body as Array<BurnListStatus>)
    );
  }
  BurnListGetBurnListRegionsResponse(): __Observable<__StrictHttpResponse<Array<BurnListRegion>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/BurnList/GetBurnListRegions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BurnListRegion>>;
      })
    );
  }  BurnListGetBurnListRegions(): __Observable<Array<BurnListRegion>> {
    return this.BurnListGetBurnListRegionsResponse().pipe(
      __map(_r => _r.body as Array<BurnListRegion>)
    );
  }

  /**
   * @param params The `BurnListService.BurnListGetBurnListsParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `typeId`:
   *
   * - `regionId`:
   */
  BurnListGetBurnListsResponse(params: BurnListService.BurnListGetBurnListsParams): __Observable<__StrictHttpResponse<Array<BurnList>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.typeId != null) __params = __params.set('typeId', params.typeId.toString());
    if (params.regionId != null) __params = __params.set('regionId', params.regionId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/BurnList/GetBurnLists/${encodeURIComponent(String(params.customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BurnList>>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListGetBurnListsParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `typeId`:
   *
   * - `regionId`:
   */
  BurnListGetBurnLists(params: BurnListService.BurnListGetBurnListsParams): __Observable<Array<BurnList>> {
    return this.BurnListGetBurnListsResponse(params).pipe(
      __map(_r => _r.body as Array<BurnList>)
    );
  }

  /**
   * @param params The `BurnListService.BurnListGetBurnListParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnListId`:
   */
  BurnListGetBurnListResponse(params: BurnListService.BurnListGetBurnListParams): __Observable<__StrictHttpResponse<BurnList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/BurnList/GetBurnList/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.burnListId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnList>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListGetBurnListParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnListId`:
   */
  BurnListGetBurnList(params: BurnListService.BurnListGetBurnListParams): __Observable<BurnList> {
    return this.BurnListGetBurnListResponse(params).pipe(
      __map(_r => _r.body as BurnList)
    );
  }

  /**
   * @param burnList undefined
   */
  BurnListCreateBurnListResponse(burnList: BurnList): __Observable<__StrictHttpResponse<BurnList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = burnList;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/BurnList/CreateBurnList`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnList>;
      })
    );
  }
  /**
   * @param burnList undefined
   */
  BurnListCreateBurnList(burnList: BurnList): __Observable<BurnList> {
    return this.BurnListCreateBurnListResponse(burnList).pipe(
      __map(_r => _r.body as BurnList)
    );
  }

  /**
   * @param burnList undefined
   */
  BurnListUpdateBurnListResponse(burnList: BurnList): __Observable<__StrictHttpResponse<BurnList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = burnList;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/BurnList/UpdateBurnList`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnList>;
      })
    );
  }
  /**
   * @param burnList undefined
   */
  BurnListUpdateBurnList(burnList: BurnList): __Observable<BurnList> {
    return this.BurnListUpdateBurnListResponse(burnList).pipe(
      __map(_r => _r.body as BurnList)
    );
  }

  /**
   * @param params The `BurnListService.BurnListUpdateBurnListStatusParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnListStatusId`:
   *
   * - `burnListId`:
   */
  BurnListUpdateBurnListStatusResponse(params: BurnListService.BurnListUpdateBurnListStatusParams): __Observable<__StrictHttpResponse<BurnList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/BurnList/UpdateBurnListStatus/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.burnListId))}/${encodeURIComponent(String(params.burnListStatusId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnList>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListUpdateBurnListStatusParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnListStatusId`:
   *
   * - `burnListId`:
   */
  BurnListUpdateBurnListStatus(params: BurnListService.BurnListUpdateBurnListStatusParams): __Observable<BurnList> {
    return this.BurnListUpdateBurnListStatusResponse(params).pipe(
      __map(_r => _r.body as BurnList)
    );
  }

  /**
   * @param params The `BurnListService.BurnListDeleteBurnListParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnListId`:
   */
  BurnListDeleteBurnListResponse(params: BurnListService.BurnListDeleteBurnListParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/BurnList/DeleteBurnList/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.burnListId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListDeleteBurnListParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnListId`:
   */
  BurnListDeleteBurnList(params: BurnListService.BurnListDeleteBurnListParams): __Observable<Blob> {
    return this.BurnListDeleteBurnListResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `BurnListService.BurnListAddBurnCoupParams` containing the following parameters:
   *
   * - `geoAssetId`:
   *
   * - `customerId`:
   *
   * - `burnListId`:
   */
  BurnListAddBurnCoupResponse(params: BurnListService.BurnListAddBurnCoupParams): __Observable<__StrictHttpResponse<BurnList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/BurnList/AddBurnCoup/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.burnListId))}/${encodeURIComponent(String(params.geoAssetId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnList>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListAddBurnCoupParams` containing the following parameters:
   *
   * - `geoAssetId`:
   *
   * - `customerId`:
   *
   * - `burnListId`:
   */
  BurnListAddBurnCoup(params: BurnListService.BurnListAddBurnCoupParams): __Observable<BurnList> {
    return this.BurnListAddBurnCoupResponse(params).pipe(
      __map(_r => _r.body as BurnList)
    );
  }

  /**
   * @param params The `BurnListService.BurnListRemoveBurnCoupParams` containing the following parameters:
   *
   * - `geoAssetId`:
   *
   * - `customerId`:
   *
   * - `burnListId`:
   */
  BurnListRemoveBurnCoupResponse(params: BurnListService.BurnListRemoveBurnCoupParams): __Observable<__StrictHttpResponse<BurnList>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/BurnList/RemoveBurnCoup/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.burnListId))}/${encodeURIComponent(String(params.geoAssetId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnList>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListRemoveBurnCoupParams` containing the following parameters:
   *
   * - `geoAssetId`:
   *
   * - `customerId`:
   *
   * - `burnListId`:
   */
  BurnListRemoveBurnCoup(params: BurnListService.BurnListRemoveBurnCoupParams): __Observable<BurnList> {
    return this.BurnListRemoveBurnCoupResponse(params).pipe(
      __map(_r => _r.body as BurnList)
    );
  }

  /**
   * @param params The `BurnListService.BurnListDisableBurnCoupParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnCoupId`:
   */
  BurnListDisableBurnCoupResponse(params: BurnListService.BurnListDisableBurnCoupParams): __Observable<__StrictHttpResponse<BurnCoup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/BurnList/DisableBurnCoup/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.burnCoupId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnCoup>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListDisableBurnCoupParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnCoupId`:
   */
  BurnListDisableBurnCoup(params: BurnListService.BurnListDisableBurnCoupParams): __Observable<BurnCoup> {
    return this.BurnListDisableBurnCoupResponse(params).pipe(
      __map(_r => _r.body as BurnCoup)
    );
  }

  /**
   * @param params The `BurnListService.BurnListEnableBurnCoupParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnCoupId`:
   */
  BurnListEnableBurnCoupResponse(params: BurnListService.BurnListEnableBurnCoupParams): __Observable<__StrictHttpResponse<BurnCoup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/BurnList/EnableBurnCoup/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.burnCoupId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnCoup>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListEnableBurnCoupParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnCoupId`:
   */
  BurnListEnableBurnCoup(params: BurnListService.BurnListEnableBurnCoupParams): __Observable<BurnCoup> {
    return this.BurnListEnableBurnCoupResponse(params).pipe(
      __map(_r => _r.body as BurnCoup)
    );
  }

  /**
   * @param params The `BurnListService.BurnListStartBurnParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnCoupId`:
   */
  BurnListStartBurnResponse(params: BurnListService.BurnListStartBurnParams): __Observable<__StrictHttpResponse<BurnCoup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/BurnList/StartBurn/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.burnCoupId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnCoup>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListStartBurnParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnCoupId`:
   */
  BurnListStartBurn(params: BurnListService.BurnListStartBurnParams): __Observable<BurnCoup> {
    return this.BurnListStartBurnResponse(params).pipe(
      __map(_r => _r.body as BurnCoup)
    );
  }

  /**
   * @param params The `BurnListService.BurnListFinishBurnParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnCoupId`:
   */
  BurnListFinishBurnResponse(params: BurnListService.BurnListFinishBurnParams): __Observable<__StrictHttpResponse<BurnCoup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/BurnList/FinishBurn/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.burnCoupId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnCoup>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListFinishBurnParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnCoupId`:
   */
  BurnListFinishBurn(params: BurnListService.BurnListFinishBurnParams): __Observable<BurnCoup> {
    return this.BurnListFinishBurnResponse(params).pipe(
      __map(_r => _r.body as BurnCoup)
    );
  }

  /**
   * @param params The `BurnListService.BurnListCancelBurnParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnCoupId`:
   */
  BurnListCancelBurnResponse(params: BurnListService.BurnListCancelBurnParams): __Observable<__StrictHttpResponse<BurnCoup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/BurnList/CancelBurn/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.burnCoupId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnCoup>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListCancelBurnParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `burnCoupId`:
   */
  BurnListCancelBurn(params: BurnListService.BurnListCancelBurnParams): __Observable<BurnCoup> {
    return this.BurnListCancelBurnResponse(params).pipe(
      __map(_r => _r.body as BurnCoup)
    );
  }

  /**
   * @param params The `BurnListService.BurnListAddCommentParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `customerId`:
   *
   * - `burnListId`:
   */
  BurnListAddCommentResponse(params: BurnListService.BurnListAddCommentParams): __Observable<__StrictHttpResponse<BurnListComment>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;


    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/BurnList/AddComment/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.burnListId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnListComment>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListAddCommentParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `customerId`:
   *
   * - `burnListId`:
   */
  BurnListAddComment(params: BurnListService.BurnListAddCommentParams): __Observable<BurnListComment> {
    return this.BurnListAddCommentResponse(params).pipe(
      __map(_r => _r.body as BurnListComment)
    );
  }

  /**
   * @param params The `BurnListService.BurnListUpdateCommentParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `customerId`:
   *
   * - `commentId`:
   */
  BurnListUpdateCommentResponse(params: BurnListService.BurnListUpdateCommentParams): __Observable<__StrictHttpResponse<BurnListComment>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;


    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/BurnList/UpdateComment/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.commentId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BurnListComment>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListUpdateCommentParams` containing the following parameters:
   *
   * - `request`:
   *
   * - `customerId`:
   *
   * - `commentId`:
   */
  BurnListUpdateComment(params: BurnListService.BurnListUpdateCommentParams): __Observable<BurnListComment> {
    return this.BurnListUpdateCommentResponse(params).pipe(
      __map(_r => _r.body as BurnListComment)
    );
  }

  /**
   * @param params The `BurnListService.BurnListDeleteCommentParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `commentId`:
   */
  BurnListDeleteCommentResponse(params: BurnListService.BurnListDeleteCommentParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/BurnList/DeleteComment/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.commentId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `BurnListService.BurnListDeleteCommentParams` containing the following parameters:
   *
   * - `customerId`:
   *
   * - `commentId`:
   */
  BurnListDeleteComment(params: BurnListService.BurnListDeleteCommentParams): __Observable<Blob> {
    return this.BurnListDeleteCommentResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module BurnListService {

  /**
   * Parameters for BurnListGetBurnLists
   */
  export interface BurnListGetBurnListsParams {
    customerId: number;
    typeId?: null | number;
    regionId?: null | number;
  }

  /**
   * Parameters for BurnListGetBurnList
   */
  export interface BurnListGetBurnListParams {
    customerId: number;
    burnListId: number;
  }

  /**
   * Parameters for BurnListUpdateBurnListStatus
   */
  export interface BurnListUpdateBurnListStatusParams {
    customerId: number;
    burnListStatusId: number;
    burnListId: number;
  }

  /**
   * Parameters for BurnListDeleteBurnList
   */
  export interface BurnListDeleteBurnListParams {
    customerId: number;
    burnListId: number;
  }

  /**
   * Parameters for BurnListAddBurnCoup
   */
  export interface BurnListAddBurnCoupParams {
    geoAssetId: number;
    customerId: number;
    burnListId: number;
  }

  /**
   * Parameters for BurnListRemoveBurnCoup
   */
  export interface BurnListRemoveBurnCoupParams {
    geoAssetId: number;
    customerId: number;
    burnListId: number;
  }

  /**
   * Parameters for BurnListDisableBurnCoup
   */
  export interface BurnListDisableBurnCoupParams {
    customerId: number;
    burnCoupId: number;
  }

  /**
   * Parameters for BurnListEnableBurnCoup
   */
  export interface BurnListEnableBurnCoupParams {
    customerId: number;
    burnCoupId: number;
  }

  /**
   * Parameters for BurnListStartBurn
   */
  export interface BurnListStartBurnParams {
    customerId: number;
    burnCoupId: number;
  }

  /**
   * Parameters for BurnListFinishBurn
   */
  export interface BurnListFinishBurnParams {
    customerId: number;
    burnCoupId: number;
  }

  /**
   * Parameters for BurnListCancelBurn
   */
  export interface BurnListCancelBurnParams {
    customerId: number;
    burnCoupId: number;
  }

  /**
   * Parameters for BurnListAddComment
   */
  export interface BurnListAddCommentParams {
    request: AddCommentRequest;
    customerId: number;
    burnListId: number;
  }

  /**
   * Parameters for BurnListUpdateComment
   */
  export interface BurnListUpdateCommentParams {
    request: UpdateCommentRequest;
    customerId: number;
    commentId: number;
  }

  /**
   * Parameters for BurnListDeleteComment
   */
  export interface BurnListDeleteCommentParams {
    customerId: number;
    commentId: number;
  }
}

export { BurnListService }
